// extracted by mini-css-extract-plugin
export default {"container":"Fraudster_container__geHmP","dashboard":"Fraudster_dashboard__bKWIa","button":"Fraudster_button__xxuEM"};